var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"width":"600","value":_vm.value},on:{"input":function (newValue) {
      this$1.$emit('input', newValue);
    }}},[_c('v-card',{attrs:{"tile":""}},[_c('v-card-title',{domProps:{"textContent":_vm._s(_vm.title)}}),_c('v-card-text',{domProps:{"innerHTML":_vm._s(_vm.content)}}),_c('v-card-actions',[_c('v-spacer'),_c('v-btn',{attrs:{"text":"","color":"primary"},on:{"click":function($event){return _vm.close()}}},[_vm._v(" "+_vm._s(_vm.$t('general.close'))+" ")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }